import { render, staticRenderFns } from "./DisputeDetail.vue?vue&type=template&id=69f56a00&"
import script from "./DisputeDetail.vue?vue&type=script&lang=js&"
export * from "./DisputeDetail.vue?vue&type=script&lang=js&"
import style0 from "./DisputeDetail.vue?vue&type=style&index=0&id=69f56a00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports